/**
 * Single source of truth for the "pending premium request" dialog copy.
 *
 * Every surface that surfaces the pending-approval message — the global
 * UpgradeFlowContext dialog and the inline UpgradePrompt card — MUST read its
 * title and description through these constants so the wording can never
 * diverge between triggers.
 *
 * Fallbacks below mirror src/locales/tr.json. The English copy lives in
 * src/locales/en.json under the same keys.
 */
export const PENDING_REQUEST_COPY = {
  titleKey: "pendingRequest.title",
  titleFallback: "Talebiniz Onay Bekliyor",
  descKey: "pendingRequest.desc",
  descFallback:
    "Mevcut abonelik talebiniz inceleniyor. Onaylandığında premium içeriklere otomatik olarak erişebileceksiniz.",
  viewRequestKey: "pendingRequest.viewRequest",
  viewRequestFallback: "Talebimi Gör",
} as const;
